/* global HSCore */

import React, { useContext, useEffect, useRef } from "react";
import DomainRating from "../../Placement/DomainRating";
import LanguageContext from "../../../utils/Contexts/LanguageContext";

function Statistics() {
  const { t } = useContext(LanguageContext);
  const dummyData = {
    domain: "realtytimes.com",
    da: 58,
    dr: 77,
    traffic: 1484,
    history: {
      da: [
        { date: "2025-05-01", value: 57 },
        { date: "2024-11-01", value: 58 },
        { date: "2024-10-01", value: 58 },
        { date: "2024-09-01", value: 58 },
        { date: "2024-08-01", value: 58 },
      ],
      dr: [
        { date: "2025-05-01", value: 77 },
        { date: "2024-11-01", value: 77 },
        { date: "2024-10-01", value: 77 },
        { date: "2024-09-01", value: 77 },
        { date: "2024-08-01", value: 77 },
      ],
      traffic: [
        { date: "2024-12-01", value: 1671 },
        { date: "2024-11-01", value: 1728 },
        { date: "2024-10-01", value: 1484 },
        { date: "2024-09-01", value: 1401 },
        { date: "2024-05-01", value: 2433 },
        { date: "2024-01-01", value: 3839 },
      ],
      prices: {
        links: {
          min: [
            { date: "2025-05-01", value: 20 },

            { date: "2025-04-01", value: 20 },

            { date: "2025-03-01", value: 11 },

            { date: "2025-02-01", value: 11 },

            { date: "2025-01-01", value: 11 },

            { date: "2024-12-01", value: 18 },
          ],
          max: [
            { date: "2025-05-01", value: 6648 },

            { date: "2025-04-01", value: 1502 },

            { date: "2025-03-01", value: 1502 },

            { date: "2025-02-01", value: 1502 },

            { date: "2025-01-01", value: 1502 },

            { date: "2024-12-01", value: 1502 },
          ],
        },
      },
    },
  };

  const hsInitRef = useRef(null);
  useEffect(() => {
    if (!hsInitRef.current) {
      HSCore.components.HSTomSelect.init(".js-select-rating");
      hsInitRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tomSelectOptionsType = {
    hideSearch: true,
    dropdownParent: "body",
  };

  const allDates = [
    { value: "1", name: t("Last Year") },
    { value: "6", name: t("Last 6 Month") },
    { value: "0", name: t("Last 3 Month") },
    { value: "5", name: t("Last Month") },
    { value: "7", name: t("Last Week") },
    { value: "4", name: t("Current Week") },
    { value: "2", name: t("Next Month") },
  ];

  useEffect(() => {
    const selectElement = document.querySelector(".js-select-rating");

    if (!selectElement || !selectElement.tomselect) return;
    const instance = selectElement.tomselect;

    const handleScroll = () => {
      const rect = instance.wrapper.getBoundingClientRect();
      const isOutOfView = rect.top > window.innerHeight || rect.bottom < 0;
      if (isOutOfView) {
        instance.close();
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  return (
    <div className="card p-3 overflow-hidden cardSetting">
      <div className="d-flex justify-content-between mb-3 flex-wrap">
        <h4
          className="card-title"
          style={{ alignSelf: "end", lineHeight: "150%" }}
        >
          {t("General Website Statistics (4)")}
        </h4>

        <div>
          <>
            <ul
              className="nav nav-segment statistic-date-range align-items-center justify-content-between"
              role="tablist"
            >
              {allDates.map((status) => {
                return (
                  <li className="nav-item contract-nav" key={status.value}>
                    <a
                      className={`js-loading-state-invoker nav-link ${
                        status.value === "6" ? "active" : ""
                      }`}
                      data-bs-toggle="pill"
                      href="#nav-one-eg1"
                      role="tab"
                      id="tab-6"
                      aria-controls="nav-one-eg1"
                      data-hs-loading-state-options='{
                        "targetEl": "#nav-one-eg1",
                        "removeLoaderDelay": "300"
                      }'
                      style={{ paddingTop: "0.2rem", paddingBottom: "0.4rem" }}
                    >
                      {status.name}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="tom-select-custom tom-select-stats-date-range position-relative">
              <select
                className="js-select-rating form-select js-stats-date"
                autoComplete="off"
                data-hs-tom-select-options={JSON.stringify(
                  tomSelectOptionsType
                )}
                name="type"
              >
                {allDates.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.name}
                  </option>
                ))}
              </select>
            </div>
          </>
        </div>
      </div>

      <div
        className="mb-3"
        style={{
          borderBottom: `2px solid var(--border)`,
          marginLeft: "-30px",
          marginRight: "-30px",
        }}
      ></div>
      <DomainRating domainRating={dummyData} flag={true} />
    </div>
  );
}

export default Statistics;
